import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isArray, isEqual, isVueComponent, cloneVNode, extractVNodeData } from '@cloud-sn/v-utils';
import Trigger from '@cloud-sn/v-trigger';
import Input from '../input';
import Icon from '../icon';
import Menu from './menu';
import { buildComponentName } from '../utils';
import { DEFAULT_FIELD_NAMES } from './utils';
import placements from './placements';
import StoreMixin from './mixins/store';
import AsyncMixin from './mixins/async';
export default {
  name: buildComponentName('Cascader'),
  mixins: [StoreMixin, AsyncMixin],
  props: {
    prefixCls: {
      type: String,
      default: 'ux-cascader'
    },
    inputPrefixCls: {
      type: String,
      default: 'ux-input'
    },
    dataSource: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadData: {
      type: Function,
      default: null
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    popupClass: {
      type: [String, Object, Array],
      default: ''
    },
    popupStyle: {
      type: Object,
      default: null
    },
    popupPlacement: {
      type: String,
      default: 'bottomLeft'
    },
    popupVisible: {
      type: Boolean,
      default: false
    },
    getPopupContainer: {
      type: Function,
      default: undefined
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    size: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['large', 'default', 'small', ''].indexOf(val) > -1;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    notFoundContent: {
      type: String,
      default: 'Not Found'
    },
    expandTrigger: {
      type: String,
      default: 'click',
      validator: function validator(val) {
        return ['hover', 'click'].indexOf(val) > -1;
      }
    },
    changeOnSelect: {
      type: Boolean,
      default: false
    },
    fieldNames: {
      type: Object,
      default: function _default() {
        return DEFAULT_FIELD_NAMES;
      }
    },
    transitionName: {
      type: String,
      default: 'slide-up'
    },
    builtinPlacements: {
      type: Object,
      default: function _default() {
        return placements;
      }
    },
    displayRender: {
      type: Function,
      default: function _default(labels) {
        return labels.join(' / ');
      }
    },
    renderLabel: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      innerValue: [],
      selectedValue: [],
      loadingSelectedValue: [],
      // 第一层级 节点
      rootNode: [],
      innerVisible: false,
      searchValue: '',
      inputFocus: false
    };
  },
  computed: {
    normalizeFieldNames: function normalizeFieldNames() {
      var fieldNames = this.fieldNames;
      return _objectSpread({}, DEFAULT_FIELD_NAMES, {}, fieldNames);
    },
    valueField: function valueField() {
      return this.normalizeFieldNames.value;
    },
    labelField: function labelField() {
      return this.normalizeFieldNames.label;
    },
    childrenField: function childrenField() {
      return this.normalizeFieldNames.children;
    },
    activeNodes: function activeNodes() {
      var selectedValue = this.selectedValue,
          getNodesByValues = this.getNodesByValues;
      return getNodesByValues(selectedValue);
    },
    showNodes: function showNodes() {
      var rootNode = this.rootNode,
          activeNodes = this.activeNodes,
          forceUpdateTriggerAlign = this.forceUpdateTriggerAlign;
      var nodes = activeNodes.reduce(function (r, node) {
        // 每一层级获取下一级 节点列表
        var children = node.children;

        if (isArray(children) && children.length > 0) {
          r.push(children);
        }

        return r;
      }, [rootNode]);
      forceUpdateTriggerAlign();
      return nodes;
    },
    triggerClasses: function triggerClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          inputFocus = this.inputFocus,
          searchValue = this.searchValue,
          showSearch = this.showSearch,
          size = this.size;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-picker"), true), _defineProperty(_ref, "".concat(prefixCls, "-picker-disabled"), disabled), _defineProperty(_ref, "".concat(prefixCls, "-picker-focused"), inputFocus), _defineProperty(_ref, "".concat(prefixCls, "-picker-with-value"), !!searchValue), _defineProperty(_ref, "".concat(prefixCls, "-picker-show-search"), showSearch), _defineProperty(_ref, "".concat(prefixCls, "-picker-").concat(size === 'large' ? 'lg' : 'sm'), size === 'large' || size === 'small'), _ref;
    } // displayLabel() {},

  },
  watch: {
    dataSource: function dataSource(nVal) {
      if (!isArray(nVal)) return;
      var clearNodesMap = this.clearNodesMap,
          createNodes = this.createNodes;
      clearNodesMap();
      this.rootNode = createNodes(nVal, null, 0);
    },
    value: function value(nVal) {
      // if (!isEqual(nVal, oVal)) {
      this.setInnerValue(nVal, false); // }
    },
    popupVisible: function popupVisible(nVal, oVal) {
      if (nVal !== oVal) {
        this.setInnerVisible(nVal, false);
      }
    }
  },
  created: function created() {
    var _this = this;

    // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/307
    this.loadRootNodes().then(function () {
      var value = _this.value,
          setInnerValue = _this.setInnerValue,
          setInnerVisible = _this.setInnerVisible,
          popupVisible = _this.popupVisible;
      setInnerValue(value, false);
      setInnerVisible(popupVisible, false);
    });
  },
  methods: {
    getDisplayLabel: function getDisplayLabel() {
      var innerValue = this.innerValue,
          getNodesByValues = this.getNodesByValues,
          displayRender = this.displayRender;
      var nodes = getNodesByValues(innerValue);
      return displayRender(nodes.map(function (node) {
        return node.label;
      }), nodes.map(function (node) {
        return _objectSpread({}, node.originNode);
      }));
    },
    forceUpdateTriggerAlign: function forceUpdateTriggerAlign() {
      var triggerRef = this.$refs.triggerRef,
          innerVisible = this.innerVisible;

      if (triggerRef && innerVisible) {
        this.$nextTick(function () {
          triggerRef.forcePopupAlign();
        });
      }
    },
    focus: function focus() {
      var triggerNodeRef = this.$refs.triggerNodeRef;

      if (triggerNodeRef) {
        triggerNodeRef.focus();
      }
    },
    blur: function blur() {
      var triggerNodeRef = this.$refs.triggerNodeRef;

      if (triggerNodeRef) {
        triggerNodeRef.blur();
      }
    },
    loadRootNodes: function loadRootNodes() {
      var _this2 = this;

      var dataSource = this.dataSource,
          createNodes = this.createNodes,
          canAsync = this.canAsync,
          asyncNode = this.asyncNode;
      return new Promise(function (resolve) {
        if (isArray(dataSource) && dataSource.length > 0) {
          _this2.rootNode = createNodes(dataSource, null, 0);
          resolve();
        } else if (canAsync()) {
          asyncNode().then(function (nodes) {
            _this2.rootNode = nodes || [];
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    getNodesByValues: function getNodesByValues() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var getNode = this.getNode;
      var nodes = !isArray(value) ? [] : value.map(function (val, i) {
        var valuePath = value.slice(0, i + 1);
        return getNode(valuePath);
      }).filter(function (node) {
        return !!node;
      });
      return nodes;
    },
    setInnerValue: function setInnerValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var syncSelectedValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var getNodesByValues = this.getNodesByValues;

      if (syncSelectedValue) {
        this.selectedValue = value;
      }

      this.innerValue = value; // 初始化时不触发

      if (trigger) {
        var nodes = getNodesByValues(value).map(function (node) {
          return _objectSpread({}, node.originNode);
        });

        var out = _toConsumableArray(value);

        this.$emit('input', out, nodes);
        this.$emit('change', out, nodes);
      }
    },
    setInnerVisible: function setInnerVisible(visible) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var innerValue = this.innerValue,
          setInnerValue = this.setInnerValue,
          innerVisible = this.innerVisible;

      if (innerVisible !== visible) {
        this.innerVisible = visible;

        if (visible) {
          setInnerValue(innerValue, false);
          this.inputFocus = true;
        } else {
          this.inputFocus = false;
          this.searchValue = '';
        } // 初始化时不触发


        if (trigger) {
          this.$emit('popup-visible-change', visible);
        }
      }
    },
    getActiveValue: function getActiveValue(node) {
      var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var selectedValue = this.selectedValue;
      var nodeValue = node.value;
      var activeValue;

      if (async && nodeValue === selectedValue[node.level]) {
        activeValue = selectedValue;
      } else {
        // 选中层级之后的原有的层级数据都无效
        activeValue = selectedValue.slice(0, node.level);
        activeValue.push(node.value);
      }

      return activeValue;
    },
    syncValueAndVisible: function syncValueAndVisible(e, node, value) {
      var syncSelectedValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var expandTrigger = this.expandTrigger,
          changeOnSelect = this.changeOnSelect,
          setInnerValue = this.setInnerValue,
          setInnerVisible = this.setInnerVisible;
      var isHoverTriggerClick = expandTrigger === 'hover' && e.type === 'click';
      var isCanSelect = expandTrigger === 'click' || isHoverTriggerClick;

      if ((!node.isParent || changeOnSelect) && isCanSelect) {
        setInnerValue(value, true, syncSelectedValue);

        if (!node.isParent || changeOnSelect && isHoverTriggerClick) {
          setInnerVisible(false);
        }
      }
    },
    updateSelectedValue: function updateSelectedValue(e, node) {
      var getActiveValue = this.getActiveValue,
          syncValueAndVisible = this.syncValueAndVisible; // 选中层级之后的原有的层级数据都无效

      var activeValue = getActiveValue(node);
      this.selectedValue = activeValue;
      syncValueAndVisible(e, node, activeValue, true);
    },
    onMenuItemSelect: function onMenuItemSelect(e, node) {
      var _this3 = this;

      var triggerNodeRef = this.$refs.triggerNodeRef,
          canAsync = this.canAsync,
          getActiveValue = this.getActiveValue,
          asyncNode = this.asyncNode,
          setInnerValue = this.setInnerValue,
          updateSelectedValue = this.updateSelectedValue,
          syncValueAndVisible = this.syncValueAndVisible; // 重设焦点

      if (triggerNodeRef) {
        triggerNodeRef.focus();
      }

      if (canAsync(node)) {
        var activeValue = getActiveValue(node, true);
        this.loadingSelectedValue = activeValue; // 在数据加载完之前,只显示当前层级节点

        var currentSelectedValue = activeValue.slice(0, activeValue.length - 1);
        this.selectedValue = currentSelectedValue;
        syncValueAndVisible(e, node, activeValue, false);
        asyncNode(node).then(function () {
          // 如果用户在加载完成前已选择其他选项, 此时 应保持用户选中
          if (isEqual(currentSelectedValue, _this3.selectedValue)) {
            // 强行触发 使 `displayLabel` 重新获取值,**其实无效,改用getDisplayLabel来处理** hw 2018-12-12
            setInnerValue(_toConsumableArray(activeValue), false);
          }

          _this3.loadingSelectedValue = [];
        });
      } else {
        this.loadingSelectedValue = [];
        updateSelectedValue(e, node);
      }
    },
    onClear: function onClear(e) {
      var searchValue = this.searchValue,
          setInnerValue = this.setInnerValue,
          setInnerVisible = this.setInnerVisible;
      e.stopPropagation();
      e.preventDefault();

      if (searchValue) {
        this.searchValue = '';
      } else {
        setInnerValue([]);
        setInnerVisible(false);
      }
    },
    onSearchInputClick: function onSearchInputClick(e) {
      var inputFocus = this.inputFocus,
          innerVisible = this.innerVisible;

      if (inputFocus || innerVisible) {
        e.stopPropagation();
      }
    },
    onSearchInputBlur: function onSearchInputBlur() {
      this.inputFocus = false;
    },
    onSearchInput: function onSearchInput(val) {
      this.searchValue = val;
    },
    getSlotDefaultTriggerNode: function getSlotDefaultTriggerNode() {
      var h = this.$createElement;
      var slotDefault = this.$slots.default,
          disabled = this.disabled;
      var triggerNode = null;

      if (!slotDefault || !slotDefault[0]) {
        return triggerNode;
      }

      var slotNode = slotDefault[0];
      var slotNodeData = extractVNodeData(slotNode, isVueComponent(slotNode));
      return h("template", {
        "slot": "trigger"
      }, [cloneVNode(slotNode, {
        attrs: _objectSpread({}, slotNodeData.attrs, {
          tabindex: disabled ? undefined : 0
        })
      })]);
    },
    renderTrigger: function renderTrigger() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          inputPrefixCls = this.inputPrefixCls,
          disabled = this.disabled,
          placeholder = this.placeholder,
          showSearch = this.showSearch,
          innerVisible = this.innerVisible,
          triggerClasses = this.triggerClasses,
          allowClear = this.allowClear,
          innerValue = this.innerValue,
          onClear = this.onClear,
          searchValue = this.searchValue,
          getDisplayLabel = this.getDisplayLabel,
          getSlotDefaultTriggerNode = this.getSlotDefaultTriggerNode,
          onSearchInput = this.onSearchInput,
          onSearchInputClick = this.onSearchInputClick,
          onSearchInputBlur = this.onSearchInputBlur;
      var displayLabel = getDisplayLabel();
      var triggerNode = getSlotDefaultTriggerNode();

      if (!triggerNode) {
        var _arrowCls;

        var arrowCls = (_arrowCls = {}, _defineProperty(_arrowCls, "".concat(prefixCls, "-picker-arrow"), true), _defineProperty(_arrowCls, "".concat(prefixCls, "-picker-arrow-expand"), innerVisible), _arrowCls);
        var inputProps = {
          prefixCls: inputPrefixCls,
          disabled: disabled,
          value: searchValue
        };
        var inputAttrs = {
          placeholder: innerValue.length > 0 ? '' : placeholder,
          readonly: !showSearch
        };
        var inputOn = {
          input: onSearchInput
        };

        if (showSearch) {
          inputOn.click = onSearchInputClick;
          inputOn.blur = onSearchInputBlur;
        } // eslint-disable-next-line max-len


        var clearElement = allowClear && !disabled && innerValue.length > 0 || !disabled && !!searchValue ? h(Icon, {
          "key": "clear",
          "attrs": {
            "type": "close_circle"
          },
          "class": "".concat(prefixCls, "-picker-clear"),
          "on": {
            "click": onClear
          }
        }) : null;
        triggerNode = h("span", {
          "slot": "trigger",
          "ref": "triggerNodeRef",
          "attrs": {
            "tabIndex": disabled ? undefined : 0
          },
          "class": triggerClasses
        }, [h("span", {
          "class": "".concat(prefixCls, "-picker-label")
        }, [displayLabel]), h(Input, _mergeJSXProps([{}, {
          class: ["".concat(prefixCls, "-input")],
          props: inputProps,
          attrs: inputAttrs,
          on: inputOn
        }])), clearElement, h(Icon, {
          "key": "down",
          "attrs": {
            "type": "down"
          },
          "class": arrowCls
        })]);
      }

      return triggerNode;
    },
    renderPopup: function renderPopup() {
      var h = this.$createElement;
      var $scopedSlots = this.$scopedSlots,
          prefixCls = this.prefixCls,
          showNodes = this.showNodes,
          selectedValue = this.selectedValue,
          loadingSelectedValue = this.loadingSelectedValue,
          expandTrigger = this.expandTrigger,
          popupVisible = this.popupVisible,
          renderLabel = this.renderLabel,
          onMenuItemSelect = this.onMenuItemSelect;
      var renderLabelFn = $scopedSlots.renderLabel || renderLabel;
      return h("div", {
        "slot": "popup"
      }, [showNodes.map(function (nodes, i) {
        var menuProps = {
          prefixCls: "".concat(prefixCls, "-menu"),
          nodes: nodes,
          activeValue: loadingSelectedValue[i] || selectedValue[i],
          level: i,
          expandTrigger: expandTrigger,
          visible: popupVisible,
          renderLabel: renderLabelFn
        };
        var on = {
          select: onMenuItemSelect
        };
        return h(Menu, {
          "props": _objectSpread({}, menuProps),
          "on": _objectSpread({}, on)
        });
      })]);
    },
    onPopupVisibleChange: function onPopupVisibleChange(visible) {
      this.setInnerVisible(visible);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        disabled = this.disabled,
        innerVisible = this.innerVisible,
        builtinPlacements = this.builtinPlacements,
        popupPlacement = this.popupPlacement,
        transitionName = this.transitionName,
        popupClass = this.popupClass,
        popupStyle = this.popupStyle,
        getPopupContainer = this.getPopupContainer,
        onPopupVisibleChange = this.onPopupVisibleChange,
        renderTrigger = this.renderTrigger,
        renderPopup = this.renderPopup;
    var triggerProps = {
      prefixCls: "".concat(prefixCls, "-menus"),
      visible: innerVisible,
      actions: disabled ? [] : ['click'],
      builtinPlacements: builtinPlacements,
      popupPlacement: popupPlacement,
      popupTransitionName: transitionName,
      popupClass: popupClass,
      popupStyle: popupStyle,
      getPopupContainer: getPopupContainer
    };
    var on = {
      'popup-visible-change': onPopupVisibleChange
    };
    return h(Trigger, _mergeJSXProps2([{}, {
      props: triggerProps,
      on: on,
      ref: 'triggerRef'
    }]), [renderTrigger(), renderPopup()]);
  }
};